import Hexagon from "./SVG/hexagon.svg?react";

const HexagonIcon = () => {
  return <Hexagon />;
};

export default HexagonIcon;
